import { DataTable } from '@/components/table/DataTable';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { useLiteratureReviewSearchesService } from '@/services/literatureReviews';
import { cn } from '@/utils/classUtils';
import { Database, databases } from '@ditto/shared';
import { getPaginationRowModel } from '@tanstack/react-table';
import { useState, type FC } from 'react';
import { useParams } from 'react-router-dom';
import { useCompleteResultsColumns } from '../columns';
import { DatabaseLogo } from '../DatabaseLogo';

export const CompleteResultsTab: FC<{
  onDatabaseClick: (database: Database) => void;
}> = ({ onDatabaseClick }) => {
  const { literatureReview_id } = useParams();
  const { completeResults, literatureReviewSearches, isPending } =
    useLiteratureReviewSearchesService(literatureReview_id);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const columns = useCompleteResultsColumns();

  if (!literatureReviewSearches.length && !isPending) {
    return (
      <FlexCol className="w-full h-full items-center justify-center">
        <FlexCol className="justify-start gap-[24px] w-[450px] pt-[80px]">
          <FlexRow className="items-center justify-center w-full">
            <Text className="text-lg font-semibold">Choose A database</Text>
          </FlexRow>
          <div className="grid grid-cols-2 gap-4">
            {databases.map(database => (
              <Button
                key={database}
                className="w-full h-[70px] py-[8px] px-[12px]"
                variant="outline"
                onClick={() => onDatabaseClick(database)}
              >
                <FlexCol className="items-start justify-start gap-1 w-full">
                  <DatabaseLogo
                    database={database}
                    className={cn(database === 'openalex' ? 'h-8' : 'h-6')}
                  />
                  <Text className="text-sm font-normal">
                    {database === 'pubmed'
                      ? 'Pubmed '
                      : database === 'openalex'
                        ? 'OpenAlex'
                        : `${database} - Database`}
                  </Text>
                </FlexCol>
              </Button>
            ))}
          </div>
        </FlexCol>
      </FlexCol>
    );
  }

  return (
    <FlexCol className="w-full h-full gap-4">
      <DataTable
        columns={columns}
        data={completeResults || []}
        isLoading={isPending}
        headerStyle="darker"
        grid="bordered"
        options={{
          getPaginationRowModel: getPaginationRowModel(),
          onPaginationChange: setPagination,
          autoResetPageIndex: false,
          state: {
            pagination,
          },
        }}
      />
    </FlexCol>
  );
};
